import React from "react";

// images from public folder
const Github = `${process.env.PUBLIC_URL}/assets/github.webp`;
const Discord = `${process.env.PUBLIC_URL}/assets/discord.webp`;
const Twitter = `${process.env.PUBLIC_URL}/assets/twitter.webp`;
const Linkedin = `${process.env.PUBLIC_URL}/assets/linkedin.webp`;
const Youtube = `${process.env.PUBLIC_URL}/assets/youtube.webp`;

const HomeFooter = () => {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="bg-gradient-to-br from-[#9F9CFF] to-[#5E5ADB] px-8 md:px-12 lg:px-20 py-12 md:py-16 border-t border-white/10 text-center md:text-left font-plusJakartaSans">
      <div className="max-w-7xl mx-auto">
        <div className="md:flex md:justify-between md:items-start gap-8 md:gap-12">
          <div className="w-full md:w-2/5 mb-8 md:mb-0">
            <h4 className="text-white text-2xl md:text-3xl font-[400] font-allertaStencil mb-4">
              TWOKEY
            </h4>
            <p className="text-sm md:text-base text-white/80 w-full md:w-4/5 my-6 text-justify md:text-left leading-relaxed">
              Secure, reliable, and innovative media sharing platform designed
              for modern teams.
            </p>
            <div className="flex flex-row gap-4 w-full justify-center md:justify-start items-center">
              <img
                src={Github}
                alt="GitHub"
                className="cursor-pointer hover:scale-110 transition-transform duration-200 w-8 h-8"
              />
              <img
                src={Discord}
                alt="Discord"
                className="cursor-pointer hover:scale-110 transition-transform duration-200 w-8 h-8"
              />
              <img
                src={Twitter}
                alt="Twitter"
                className="cursor-pointer hover:scale-110 transition-transform duration-200 w-8 h-8"
              />
              <img
                src={Linkedin}
                alt="LinkedIn"
                className="cursor-pointer hover:scale-110 transition-transform duration-200 w-8 h-8"
              />
              <img
                src={Youtube}
                alt="YouTube"
                className="cursor-pointer hover:scale-110 transition-transform duration-200 w-8 h-8"
              />
            </div>
          </div>
          <div className="flex flex-wrap justify-between items-start w-full md:w-3/5 gap-8 md:gap-12">
            <div>
              <h5 className="text-white mb-6 font-bold text-base md:text-lg">
                Company
              </h5>
              <div className="flex flex-col gap-3">
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/"
                >
                  Home
                </a>
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/"
                >
                  About
                </a>
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/"
                >
                  Product
                </a>
              </div>
            </div>
            <div>
              <h5 className="text-white mb-6 font-bold text-base md:text-lg">
                Contact
              </h5>
              <div className="flex flex-col gap-3">
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/contact-us"
                >
                  Email Us
                </a>
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base cursor-pointer"
                  onClick={() => scrollTo("support")}
                >
                  Support
                </a>
              </div>
            </div>
            <div>
              <h5 className="text-white mb-6 font-bold text-base md:text-lg">
                Product
              </h5>
              <div className="flex flex-col gap-3">
                <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/"
                >
                  Pricing
                </a>
                {/* <a
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm md:text-base"
                  href="/test-pricing"
                >
                  Two key
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} TwoKey. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeFooter;
